import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Skills from '../components/sections/Skills';
import Experience from '../components/sections/Experience';
import Projects from '../components/sections/Projects';
import Contact from '../components/sections/Contact';

const HomePage = () => {
    return (
        <>
            <Hero />
            <About />
            <Skills />
            <Experience />
            <Projects />
            <Contact />
        </>
    );
};

export default HomePage;
